import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { selectActiveJobsCount } from '@cdw-ae/jobs-status-state';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-job-indicator',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatTooltipModule],
  templateUrl: './job-indicator.component.html',
  styleUrls: ['./job-indicator.component.scss'],
})
export class JobIndicatorComponent implements OnInit, OnDestroy {
  @Input() sidebarExpanded = false;
  @Input() isPanelOpen = false;
  @Output() panelToggle = new EventEmitter<void>();

  public activeJobsCount = 0;
  private destroy$ = new Subject<void>();

  constructor(private store: Store) {}

  get jobStatusText(): string {
    if (this.activeJobsCount === 0) {
      return 'No active jobs';
    } else if (this.activeJobsCount === 1) {
      return '1 job running';
    } else {
      return `${this.activeJobsCount} jobs running`;
    }
  }

  ngOnInit(): void {
    // Subscribe to active jobs count
    this.store
      .select(selectActiveJobsCount)
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => {
        this.activeJobsCount = count;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleJobsPanel(): void {
    this.panelToggle.emit();
  }
}
